function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "#FF4E00",
  rx: 3
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0H24V24H0z",
  transform: "translate(3 3)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.413 15.855h.884c.869 0 1.396.435 1.396 1.143 0 .684-.57 1.143-1.381 1.143-.816 0-1.368-.42-1.421-1.075H8.685c.058 1.275 1.108 2.11 2.641 2.11 1.524 0 2.656-.88 2.656-2.09 0-.962-.6-1.582-1.557-1.729v-.083c.747-.2 1.28-.761 1.284-1.61.005-1.012-.84-1.886-2.339-1.886-1.528 0-2.485.865-2.549 2.1h1.182c.054-.703.532-1.094 1.299-1.094.747 0 1.191.46 1.191 1.04 0 .64-.498 1.09-1.22 1.09h-.86v.941zm5.054-3.9V19h2.641c2.11 0 3.316-1.294 3.316-3.555 0-2.212-1.22-3.49-3.316-3.49h-2.641zm1.26 1.059h1.215c1.382 0 2.198.898 2.198 2.45 0 1.588-.796 2.476-2.198 2.476h-1.215v-4.926z"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  width: 38,
  height: 38,
  x: -4,
  y: -4,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

var Svg3D = function Svg3D(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3D, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3d.195af392.svg";
export { ForwardRef as ReactComponent };